import { useMutation, useQueryClient } from "react-query";
import { mutatePostFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface ExecuteCronJobParams {
  id: string;
  /**
   * Bypass the backend's "already running" guard. The scheduler now claims a job
   * before running it, so a manual run while the scheduled run (or another
   * manual run) is in progress comes back as HTTP 409. Pass force to run anyway.
   */
  force?: boolean;
}

/**
 * Manually trigger a cron job. Success -> 200. If the job is already running and
 * `force` was not set, the API responds 409 with { data: { lockedAt } } - the
 * screen catches that and offers a "Force run" confirm.
 */
export const useExecuteCronJob = () => {
  const queryClient = useQueryClient();
  return useMutation<any, any, ExecuteCronJobParams>(
    ({ id, force }) =>
      mutatePostFn(
        ENDPOINTS.CRON_JOB_EXECUTE.replace(":id", id),
        { force: !!force }
      ),
    {
      onSettled: () => {
        queryClient.invalidateQueries([ENDPOINTS.CRON_JOBS]);
      },
    }
  );
};
